import React, { useState, useRef, useContext, useCallback } from 'react';
import { uploadQuickSheetTemplate } from '../API/quickSheets';
import { AppContext } from '../util/AppContext';
import { getConfigValue } from '../util/getConfigValue';
import PropTypes from 'prop-types';
import ToastAlert from "../components/ToastAlert";


const UploadFile = ({ setDocumentId, setDocumentUploaded }) => {
    const [appState] = useContext(AppContext);
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState('');
    const fileInputRef = useRef(null);
    const validExtensions = JSON.parse(getConfigValue(appState?.config?.Widen?.Upload?.ValidExtensions, appState)?.Value || '[".pdf"]');
    const [showToast, setShowToast] = useState(false);
    const [toastTitle, setToastTitle] = useState('');
    const [toastMessage, setToastMessage] = useState('');

    const handleFileChange = (file) => {
        const fileNameParts = file.name.toLowerCase().split('.');
        const fileExtension = `.${fileNameParts[fileNameParts.length - 1]}`;
        if (file && validExtensions.includes(fileExtension)) {
            setFile(file);
            const reader = new FileReader();
            reader.onloadend = () => setPreviewUrl(reader.result);
            reader.readAsDataURL(file);
        }
        else {
            triggerToastAlert("Not a valid file type", `The file ${file.name} is not a supported file type.`);
            console.log("Not a valid file type");
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const dropFile = e.dataTransfer.files[0];
        handleFileChange(dropFile);
    };

    const onPick = useCallback((e) => {
        fileInputRef.current?.click();
    }, []);

    const onInputChange = useCallback((e) => {
        handleFileChange(e.target.files[0]);
        e.target.validExtensions = "";
    }, [handleFileChange])


    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    function triggerToastAlert(title, message) {
        setToastTitle(title);
        setToastMessage(message);
        setShowToast(true);
    }

    const handleUpload = async () => {
        if (!file) {
            return;
        }

        try {
            const uploadRes = await uploadQuickSheetTemplate(file);

            setDocumentId(uploadRes);

            setDocumentUploaded(true);

            console.log("File uploaded to Widen")
        } catch (err) {
            console.log(err)
        }
    };

    return (
        <div style={{ paddingBottom: 20, paddingTop: 20 }}>
            <h2 className="type-20 type-bold mb-3">{getConfigValue(appState?.config?.Widen?.Upload?.UploadForm?.Title?.Label, appState)?.Value || 'Upload PDF to Widen'}</h2>

            <div
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                style={{
                    border: '2px dashed #ccc',
                    padding: 40,
                    textAlign: 'center',
                    marginBottom: 20,
                    role: "region",
                    arialLabel: "File drop area"
                }}
            >
                <p><span role="image" aria-label="document" className="fa-light fa-file-lines fs-2"></span><br />{getConfigValue(appState?.config?.Widen?.Upload?.UploadForm?.DragAndDrop?.Label, appState)?.Value || 'Drag & Drop Document Here'}</p>
                <button
                    type="button"
                    onClick={onPick}
                    className='btn-cta'>{getConfigValue(appState?.config?.Widen?.Upload?.UploadForm?.Button?.Label, appState)?.Value || 'Browse Files'}</button>
                <input
                    type="file"
                    accept={getConfigValue(validExtensions?.join(','), appState)?.Value || ".pdf"}
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={onInputChange}
                />
            </div>

            {previewUrl && (
                <div style={{ height: '500px', border: '1px solid #ccc', marginBottom: 20 }}>
                    <iframe
                        src={previewUrl}
                        title={getConfigValue(appState?.config?.Widen?.Upload?.UploadForm?.Preview?.Label, appState)?.Value || 'PDF Preview'}
                        width="100%"
                        height="100%"
                    />
                </div>
            )}

            <button onClick={handleUpload} disabled={!file}>
                {getConfigValue(appState?.config?.Widen?.Upload?.UploadForm?.UploadButton?.Label, appState)?.Value || 'Upload'}
            </button>
            <ToastAlert show={showToast} setShow={setShowToast} title={toastTitle} message={toastMessage} />
        </div>
    );

};

UploadFile.propTypes = {
    setDocumentUploaded: PropTypes.func,
    setDocumentId: PropTypes.func
};

export default UploadFile